import React from 'react';
import clsx from 'clsx';
import './Title.scss';

type TitleType = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLHeadingElement>,
  HTMLHeadingElement
>;

const Title: React.FC<TitleType> = ({ className, children, ...props }) => {
  return (
    <h2 {...props} className={clsx('ui-title', className)}>
      {children}
    </h2>
  );
};

export default Title;
